
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "API-FIRST HEADLESS COMMERCE FOR YOUR MARKETPLACE",
  "date": "2020-04-04"
};
const slug = 'api-headless-commerce';
const tableOfContents = [{
  "title": "Imagine anything with Tradly API",
  "slug": "imagine-anything-with-tradly-api",
  "children": [{
    "title": "Sell Anywhere​",
    "slug": "sell-anywhere",
    "children": []
  }, {
    "title": "Scale Rapidly & Secure",
    "slug": "scale-rapidly-and-secure",
    "children": []
  }, {
    "title": "New Technologies are Pre-Built",
    "slug": "new-technologies-are-pre-built",
    "children": []
  }]
}, {
  "title": "Advanced API Platform for advanced tech startups",
  "slug": "advanced-api-platform-for-advanced-tech-startups",
  "children": []
}, {
  "title": "Make Your Marketplace Work For You",
  "slug": "make-your-marketplace-work-for-you",
  "children": []
}, {
  "title": "Think of any marketplace, Think Tradly Platform API",
  "slug": "think-of-any-marketplace-think-tradly-platform-api",
  "children": [{
    "title": "Product Marketplace",
    "slug": "product-marketplace",
    "children": []
  }, {
    "title": "Crowdfunding Platform",
    "slug": "crowdfunding-platform",
    "children": []
  }, {
    "title": "Group Marketplace",
    "slug": "group-marketplace",
    "children": []
  }, {
    "title": "New Marketplace Ideas",
    "slug": "new-marketplace-ideas",
    "children": []
  }]
}, {
  "title": "Built a great business. Do it with Tradly Platform",
  "slug": "built-a-great-business-do-it-with-tradly-platform",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1>{`API-FIRST HEADLESS COMMERCE`}</h1>
    <p>{`Build, Integrate and Extend your commerce application with powerful TRADLY PLATFORM API. Our API solutions available to build apps on different business model like C2C, B2C, B2B, social commerce and marketplace integration. Front end agnostic. Full control.  `}</p>
    <p><a parentName="p" {...{
        "href": "https://tradly.app/signup"
      }}>{`FREE ACCOUNT`}</a>{` `}</p>
    <_Heading level={2} id={"imagine-anything-with-tradly-api"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>Imagine anything with Tradly API</_Heading>
    <_Heading level={3} id={"sell-anywhere"} nextElement={{
      "type": "paragraph"
    }}>Sell Anywhere​</_Heading>
    <p>{`With API first headless commerce architecture, Tradly API allows you to expand your offering into any display experience/channels like social, apps, physical kiosks, chatbots, etc. Single source of data supplied to multiple interfaces giving your users every new experience they love.`}</p>
    <_Heading level={3} id={"scale-rapidly-and-secure"} nextElement={{
      "type": "paragraph"
    }}>Scale Rapidly & Secure</_Heading>
    <p>{`Whether you are building a simple internal apps for your organisation or building the app for the new world, our API solution are scalable powered by Amazon web servers with security and many compliance. Find more information on our API docs.`}</p>
    <_Heading level={3} id={"new-technologies-are-pre-built"} nextElement={{
      "type": "paragraph"
    }}>New Technologies are Pre-Built</_Heading>
    <p>{`New technologies like voice commerce, Intelligent search, personalization using AI or anything that matters to the commerce tech, we will be developing throughout the year for you to use. Signup for invite only private newsletter which gives updates on our product roadmap.`}</p>
    <_Heading level={2} id={"advanced-api-platform-for-advanced-tech-startups"} nextElement={{
      "type": "paragraph"
    }}>Advanced API Platform for advanced tech startups</_Heading>
    <p>{`Built by engineers to engineers. Fast. Flexible. Full control. With Tradly API, you can break the standard.`}</p>
    <_Heading level={2} id={"make-your-marketplace-work-for-you"} nextElement={{
      "type": "paragraph"
    }}>Make Your Marketplace Work For You</_Heading>
    <p>{`Set rules, manage your marketplace community, take advantage of our partner ecosystem, and collect payments. And, That’s Just a Glimpse  `}</p>
    <p><a parentName="p" {...{
        "href": "https://tradly.app/signup"
      }}>{`FREE ACCOUNT`}</a></p>
    <_Heading level={2} id={"think-of-any-marketplace-think-tradly-platform-api"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>Think of any marketplace, Think Tradly Platform API</_Heading>
    <_Heading level={3} id={"product-marketplace"} nextElement={{
      "type": "paragraph"
    }}>Product Marketplace</_Heading>
    <p>{`Built successful product general marketplace like Etsy, Depop, Letgo or AliExpress.`}</p>
    <_Heading level={3} id={"crowdfunding-platform"} nextElement={{
      "type": "paragraph"
    }}>Crowdfunding Platform</_Heading>
    <p>{`Build crowdfunding platform like Kickstarter, Gofundme, Indiegogo.`}</p>
    <_Heading level={3} id={"group-marketplace"} nextElement={{
      "type": "paragraph"
    }}>Group Marketplace</_Heading>
    <p>{`Anything starting from closed community marketplaces up to P2P group marketplaces can be launched with TradlyAPI`}</p>
    <_Heading level={3} id={"new-marketplace-ideas"} nextElement={{
      "type": "paragraph"
    }}>New Marketplace Ideas</_Heading>
    <p>{`Our infrastructure is built on platform thinking. Any two sided or multi sided marketplaces can be customised and launched.`}</p>
    <_Heading level={2} id={"built-a-great-business-do-it-with-tradly-platform"} nextElement={{
      "type": "export"
    }}>Built a great business. Do it with Tradly Platform</_Heading>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
